import { MarketplaceVendorSubscription } from "@/Contracts/Marketplace";
import {
	MarketplaceProductCountMap,
	MarketplaceProduct
} from "@/Contracts/Marketplace/Product";
import { VendorCompany } from "@/Contracts/Marketplace/Vendor";
import { Reducer } from "redux";

import {
	MarketplaceActionTypes,
	MarketplaceActions
} from "@/Actions/Marketplace";
import { ChargebeeInvoice } from "@/Contracts/Users";

export interface MarketplaceState {
	readonly isLoading: boolean;
	readonly marketplaceProducts: MarketplaceProduct[];
	readonly marketplaceVendors: VendorCompany[];
	readonly marketplaceProductCountMap: MarketplaceProductCountMap;
	readonly currentActiveMarketplaceProduct: MarketplaceProduct | null;
	readonly marketplaceSubscriptions: MarketplaceVendorSubscription[];
	readonly marketplaceInvoices: ChargebeeInvoice[];
	readonly currentActiveMarketplaceVendor: VendorCompany | null;
	readonly currentActiveMarketplaceVendorProducts: MarketplaceProduct[];
	readonly vendorProgamDetails: VendorCompany[];
	readonly vendorProgramDetailsLoading: boolean;
}

export const initialMarketplaceState: MarketplaceState = {
	isLoading: false,
	marketplaceProducts: new Array<MarketplaceProduct>(),
	marketplaceProductCountMap: new MarketplaceProductCountMap(),
	marketplaceVendors: new Array<VendorCompany>(),
	currentActiveMarketplaceProduct: null,
	marketplaceSubscriptions: new Array<MarketplaceVendorSubscription>(),
	marketplaceInvoices: new Array<ChargebeeInvoice>(),
	currentActiveMarketplaceVendor: null,
	currentActiveMarketplaceVendorProducts: [],
	vendorProgamDetails: new Array<VendorCompany>(),
	vendorProgramDetailsLoading: false
};

export const MarketplaceReducer: Reducer<
	MarketplaceState,
	MarketplaceActions
> = (
	state: MarketplaceState = initialMarketplaceState,
	action: MarketplaceActions
): MarketplaceState => {
	switch (action.type) {
		case MarketplaceActionTypes.SHOW_MARKETPLACE_LOADER: {
			return {
				...state,
				isLoading: true
			};
		}
		case MarketplaceActionTypes.HIDE_MARKETPLACE_LOADER: {
			return {
				...state,
				isLoading: false
			};
		}
		case MarketplaceActionTypes.MARKETPLACE_PRODUCTS_SUCCESSFUL: {
			return {
				...state,
				marketplaceProducts: action.products,
				marketplaceProductCountMap: action.productCount
			};
		}
		case MarketplaceActionTypes.MARKETPLACE_PRODUCT_DETAILS_SUCCESSFUL: {
			return {
				...state,
				currentActiveMarketplaceProduct:
					action.currentActiveMarketplaceProduct
			};
		}
		case MarketplaceActionTypes.MARKETPLACE_PRODUCT_DETAILS_RESET: {
			return {
				...state,
				currentActiveMarketplaceProduct: null
			};
		}
		case MarketplaceActionTypes.MARKETPLACE_VENDORS_SUCCESSFUL: {
			return {
				...state,
				marketplaceVendors: action.vendors
			};
		}
		case MarketplaceActionTypes.MARKETPLACE_SUBSCRIPTIONS_SUCCESSFUL: {
			return {
				...state,
				marketplaceSubscriptions: action.subscriptions
			};
		}
		case MarketplaceActionTypes.MARKETPLACE_INVOICES_SUCCESSFUL: {
			return {
				...state,
				marketplaceInvoices: action.invoices
			};
		}
		case MarketplaceActionTypes.MARKETPLACE_VENDOR_DETAILS_SUCCESSFUL: {
			return {
				...state,
				currentActiveMarketplaceVendor:
					action.currentActiveMarketplaceVendor
			};
		}
		case MarketplaceActionTypes.MARKETPLACE_VENDOR_DETAILS_RESET: {
			return {
				...state,
				currentActiveMarketplaceVendor: null
			};
		}
		case MarketplaceActionTypes.MARKETPLACE_VENDOR_PRODUCT_DETAILS_SUCCESSFUL: {
			return {
				...state,
				currentActiveMarketplaceVendorProducts:
					action.currentActiveMarketplaceVendorProducts
			};
		}
		case MarketplaceActionTypes.MARKETPLACE_VENDOR_PRODUCT_DETAILS_RESET: {
			return {
				...state,
				currentActiveMarketplaceVendorProducts: []
			};
		}
		case MarketplaceActionTypes.UPDATE_CLIENT_SUBSCRIPTIONS_SUCCESSFUL: {
			const subscriptionsList = state.marketplaceSubscriptions.filter(
				subscription => subscription.id !== action.subscriptions.id
			);
			const updateSubscriptionIndex =
				state.marketplaceSubscriptions.findIndex(
					subscription => subscription.id === action.subscriptions.id
				);
			if (updateSubscriptionIndex > -1) {
				subscriptionsList.splice(
					updateSubscriptionIndex,
					0,
					action.subscriptions
				);
			}
			return {
				...state,
				marketplaceSubscriptions: subscriptionsList
			};
		}
		case MarketplaceActionTypes.SHOW_VENDOR_PROGRAM_STATUS_LOADER: {
			return {
				...state,
				vendorProgramDetailsLoading: true
			};
		}
		case MarketplaceActionTypes.HIDE_VENDOR_PROGRAM_STATUS_LOADER: {
			return {
				...state,
				vendorProgramDetailsLoading: false
			};
		}
		case MarketplaceActionTypes.VENDOR_PROGRAM_STATUS_SUCCESSFUL: {
			return {
				...state,
				vendorProgamDetails: action.vendorProgamDetails
			};
		}
		default: {
			return state;
		}
	}
};

export default MarketplaceReducer;
